export type VendorItemUnitCostHint = {
  unitCostCents: number | null;
  source: 'po_line' | 'receipt_line' | 'catalog' | null;
};

const SOURCE_LABELS: Record<NonNullable<VendorItemUnitCostHint['source']>, string> = {
  po_line: 'previous PO with this vendor',
  receipt_line: 'last posted receipt from this vendor',
  catalog: 'catalog standard cost',
};

export function formatVendorUnitCostDollars(cents: number): string {
  return (cents / 100).toFixed(2);
}

export function vendorUnitCostHelperText(hint: VendorItemUnitCostHint | null): string | undefined {
  if (hint?.unitCostCents == null || !hint.source) return undefined;
  return `Prefilled from ${SOURCE_LABELS[hint.source]} ($${formatVendorUnitCostDollars(hint.unitCostCents)})`;
}
